import { sendMetrics } from "./sendMetrics";

export async function sendErrorMetric(errorType: string, additionalDimensions?: Record<string, string>) {
    return await sendMetrics([
        {
            metrics: [{ name: "Error", value: 1 }],
            dimensions: { errorType, ...additionalDimensions },
        },
    ]);
}

export async function sendEventMetric(eventName: string, additionalDimensions?: Record<string, string>) {
    return await sendMetrics([
        {
            metrics: [{ name: "Event", value: 1 }],
            dimensions: { eventName, ...additionalDimensions },
        },
    ]);
}
